ReportsMenuController.$inject = ["_", "$state", "$location", "$transitions", "storageService", "reportService", "userService", "reportCategories", "dealerService", "environmentVariables"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
/* injects from baggage-loader */
require('./reports-menu.component.html');
import angular from 'angular';
import moment from 'moment-timezone';
angular.module('AaApp.Opp').component('reportsMenu', {
  templateUrl: '/app/components/reports/reports-menu.component.html',
  controller: ReportsMenuController,
  bindings: {
    kendo: '<',
    moduleIds: '<'
  }
});

/* @ngInject */
function ReportsMenuController(_, $state, $location, $transitions, storageService, reportService, userService, reportCategories, dealerService, environmentVariables) {
  var $ctrl = this;
  $ctrl.legacyExpirationDate;
  $ctrl.opportunitiesMenuVisible;
  $ctrl.communicationMenuVisible;
  $ctrl.oneToOneMenuVisible;
  $ctrl.autoAssistantMenuVisible;
  $ctrl.geoAlertMenuVisible;
  $ctrl.partnerExportMenuVisible;
  $ctrl.showBetaReports;
  $ctrl.showQuickSightReports;
  $ctrl.oneToOneMenuDisabled;
  $ctrl.autoAssistantMenuDisabled;
  $ctrl.geoAlertMenuDisabled;
  $ctrl.partnerExportMenuDisabled;
  $ctrl.reportCategories;
  $ctrl.showLegacy;
  $ctrl.$state;
  $ctrl.isActiveMenuItem = isActiveMenuItem;
  $ctrl.$onInit = $onInit;
  $ctrl.$onChanges = $onChanges;
  $ctrl.showPerformanceReport = false;
  $ctrl.performanceReportMonthName;
  $ctrl.performanceReportYear;
  $ctrl.isAutoAlertEmployee = false;
  $ctrl.currentReportId;
  $ctrl.currentQuickSightReportId;
  $ctrl.isActiveBetaMenuItem = isActiveBetaMenuItem;
  $ctrl.isActiveQuickSightMenuItem = isActiveQuickSightMenuItem;
  $ctrl.betaReportsMenu;
  $ctrl.betaReportCategories;
  $ctrl.quickSightReportsMenu;
  $ctrl.quickSightReportsMenuVisible;
  $ctrl.performanceReportAvailable = false;
  $ctrl.monthlyPerformanceReportId;
  function $onInit() {
    $ctrl.legacyExpirationDate = new Date(2018, 0, 15);
    $ctrl.opportunitiesMenuVisible = true;
    $ctrl.communicationMenuVisible = false;
    $ctrl.oneToOneMenuDisabled = false;
    $ctrl.autoAssistantMenuDisabled = false;
    $ctrl.geoAlertMenuDisabled = false;
    $ctrl.partnerExportMenuDisabled = false;
    $ctrl.oneToOneMenuVisible = false;
    $ctrl.autoAssistantMenuVisible = false;
    $ctrl.geoAlertMenuVisible = false;
    $ctrl.partnerExportMenuVisible = false;
    $ctrl.showBetaReports = false;
    $ctrl.showQuickSightReports = false;
    $ctrl.quickSightReportsMenuVisible = false;
    $ctrl.reportCategories = reportCategories;
    $ctrl.showLegacy = $state.current.name.indexOf('legacy') > -1 && $state.current.name.indexOf('legacyoneToOneReport') < 0; // temp for legacy one-to-one
    $ctrl.$state = $state;
    $ctrl.reportsMenu = reportService.getAuthorizedReports($ctrl.moduleIds);
    $ctrl.betaReportsMenu = [];
    $ctrl.quickSightReportsMenu = [];
    setPerformanceReportMonthYear();
    loadMenu();

    // Destroy all Kendo components so memory can be GC'd
    $transitions.onExit({}, function (transition, state) {
      if ($ctrl.kendo && (state.name == 'reportsContainer' || state.parent == 'reportsContainer')) {
        $ctrl.kendo.destroy('report-render');
      }
    });
    $transitions.onSuccess({}, function (transition) {
      $ctrl.showLegacy = transition.to().name.indexOf('legacy') > -1 && transition.to().name.indexOf('legacyoneToOneReport') < 0; // temp for legacy one-to-one

      loadMenu();
      if (transition.from().parent && transition.from().parent == 'reportsContainer' && (!transition.to().parent || transition.to().parent != 'reportsContainer')) {
        storageService.removeItem('reportHeaderData');
      }
      $ctrl.currentReportId = $location.search().id;
      $ctrl.currentQuickSightReportId = $location.search().id;
    });
  }
  function setPerformanceReportMonthYear() {
    var PERFORMANCE_REPORT_START_DAY = environmentVariables.showPerformanceReportDayOfMonth || 1;
    var cultureName = storageService.getItem('cultureName') || 'en-US';
    var now = moment().locale(cultureName);
    var dayOfMonth = now.date();
    var month = now.month();
    var prevMonth = month === 0 ? 11 : month - 1;
    var year = now.year();
    var prevYear = month === 0 ? year - 1 : year;
    $ctrl.showPerformanceReport = dayOfMonth >= PERFORMANCE_REPORT_START_DAY && $ctrl.performanceReportAvailable;
    $ctrl.performanceReportMonthName = now.month(prevMonth).format("MMMM").toUpperCase();
    $ctrl.performanceReportYear = now.year(prevYear).format("YYYY");
  }
  function loadMenu() {
    var currentMenuItem = _.find($ctrl.reportsMenu, {
      id: $state.current.name
    });
    if (currentMenuItem) {
      switch (currentMenuItem.category) {
        case reportCategories.opportunities:
          $ctrl.opportunitiesMenuVisible = true;
          break;
        case reportCategories.communication:
          $ctrl.communicationMenuVisible = true;
          break;
        case reportCategories.onetoone:
          $ctrl.oneToOneMenuVisible = true;
          break;
        case reportCategories.autoassistant:
          $ctrl.autoAssistantMenuVisible = true;
          break;
        case reportCategories.geoalert:
          $ctrl.geoAlertMenuVisible = true;
          break;
        case reportCategories.partnerExport:
          $ctrl.partnerExportMenuVisible = true;
          break;
        default:
          break;
      }
    }
  }
  function fixNullCategory(report, index, reports) {
    reports[index].CategoryName = "Additional Reports"; //set all Tableau reports to this category name
  }
  function $onChanges(changes) {
    if (changes) {
      userService.getUserProfile().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(userProfile) {
          var isDealerOneTooneEnabled, isDealerAutoAssistantEnabled, isDealerGeoAlertEnabled;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                $ctrl.reportsMenu = reportService.getAuthorizedReports($ctrl.moduleIds, userProfile.isSltUser);
                $ctrl.isAutoAlertEmployee = userProfile.employeeUser;
                $ctrl.betaReportsMenu = [];
                $ctrl.showBetaReports = false;
                $ctrl.quickSightReportsMenu = [];
                $ctrl.showQuickSightReports = false;
                loadMenu();
                reportService.getBetaReportList().then(function (results) {
                  if (results && results.Success == true && results.Data && results.Data.length > 0) {
                    results.Data.forEach(fixNullCategory);
                    var tableauReports = [];
                    results.Data.forEach(function (report) {
                      if (report.Name == "Monthly Performance Report") {
                        //Monthly Performance Report does not go into the tableauReports array
                        $ctrl.monthlyPerformanceReportId = report.Id;
                        $ctrl.performanceReportAvailable = true;
                      } else {
                        tableauReports.push(report);
                      }
                    });
                    if (tableauReports.length > 0) {
                      $ctrl.showBetaReports = true;
                    }
                    $ctrl.betaReportsMenu = tableauReports.sort(byCategoryThenReportName);
                    $ctrl.currentReportId = $location.search().id;
                    var currentBetaCategory = "NO_CATEGORY";
                    if ($ctrl.currentReportId) {
                      var currentReport = _.find($ctrl.betaReportsMenu, {
                        Id: $ctrl.currentReportId
                      });
                      if (currentReport) {
                        currentBetaCategory = currentReport.CategoryName;
                      }
                    }
                    var categories = _toConsumableArray(new Set($ctrl.betaReportsMenu.map(function (r) {
                      return r.CategoryName;
                    })));
                    $ctrl.betaReportCategories = categories.map(function (r) {
                      var container = {};
                      container.categoryName = r;
                      container.isVisible = currentBetaCategory == r;
                      return container;
                    });
                    setPerformanceReportMonthYear();
                  }
                });
                reportService.getQuickSightDashboardList().then(function (results) {
                  if (results && results.Success == true && results.Data && results.Data.length > 0) {
                    $ctrl.showQuickSightReports = true;
                    $ctrl.quickSightReportsMenu = results.Data.sort(byCategoryThenReportName);
                    $ctrl.currentQuickSightReportId = $location.search().id;
                  }
                });

                // If other code hasn't yet loaded the o2o status, we need to
                // load it before checking if o2o is enabled
                if (dealerService.dealersOneToOneStatusLoaded) {
                  _context.n = 1;
                  break;
                }
                _context.n = 1;
                return dealerService.getDealersOneToOneStatus();
              case 1:
                isDealerOneTooneEnabled = dealerService.getIsSomeDealerOneToOneEnabled();
                _context.n = 2;
                return dealerService.getIsSomeDealerAutoAssistantEnabled();
              case 2:
                isDealerAutoAssistantEnabled = _context.v;
                _context.n = 3;
                return dealerService.getIsSomeDealerGeoAlertEnabled();
              case 3:
                isDealerGeoAlertEnabled = _context.v;
                // show onetoone menu only for dealers who have onetoone enabled
                $ctrl.oneToOneMenuDisabled = !isDealerOneTooneEnabled;
                $ctrl.autoAssistantMenuDisabled = !isDealerAutoAssistantEnabled;
                $ctrl.geoAlertMenuDisabled = !isDealerGeoAlertEnabled;
              case 4:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
  function byCategoryThenReportName(report1, report2) {
    if (report1.CategoryName == report2.CategoryName) {
      if (report1.Name < report2.Name) return -1;
      if (report1.Name > report2.Name) return 1;
      return 0;
    } else {
      if (report1.CategoryName < report2.CategoryName) return -1;
      if (report1.CategoryName > report2.CategoryName) return 1;
      return 0;
    }
  }
  function isActiveMenuItem(menuItem) {
    return $state.current.url.indexOf(menuItem.url) > -1 || menuItem.url == "/performance" && $location.$$search.id == $ctrl.monthlyPerformanceReportId;
  }
  function isActiveBetaMenuItem(menuItem) {
    return $ctrl.currentReportId == menuItem.Id;
  }
  function isActiveQuickSightMenuItem(menuItem) {
    return $ctrl.currentQuickSightReportId == menuItem.Id;
  }
}